<!--
 * @Description: 发票申请
--> 
<template>
	<div class="invoice-apply">
		<van-nav-bar left-text="返回"
			:title="$route.meta.title"
			@click-left="$comm.onClickLeft"
			left-arrow
			fixed>
			<template #left>
				<span class="iconfont iconshang comm-rotate-270"></span>
				<span class="comm-return">返回</span>
			</template>
		</van-nav-bar>
		<div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
		<van-tabs color="#1677FF"
			v-model="active"
			@change="onChange"
			sticky>
			<van-tab v-for="(tab, i) in tabs"
				:key="i"
				:title="tab.title">
				<div class="tab-content">
					<div class="comm-search-bar">
						<div class="bar-con">
							<van-field label="用户号"
								label-width="45px"
								placeholder=""
								readonly
								clickable
								name="picker"
								:value="value"
								@click="showPicker = true">
								<template #right-icon>
									<span class="iconfont iconxuanzesanjiao"></span>
								</template>
							</van-field>
							<van-field v-show="active===1"
								label="时间"
								label-width="45px"
								style="margin-left:10px"
								placeholder=""
								readonly
								clickable
								name="picker"
								:value="timeT"
								@click="showTimePicker = true">
								<template #right-icon>
									<span class="iconfont iconxuanzesanjiao"></span>
								</template>
							</van-field>
						</div>
					</div>
					<div v-show="active===0">
						<div v-if="applyList.length>0"
							class="invoice-list">
							<van-checkbox-group v-model="applyResult"
								ref="checkboxGroup">
								<div v-for="(apply, i) in applyList"
									:key="i">
									<div class="comm-seperator"></div>
									<invoice-item :item="apply"
										@changecheck="changeCheck"></invoice-item>
								</div>
							</van-checkbox-group>
						</div>
						<div v-if="applyList.length===0"
							style="text-align:center;">
							<img style="width:200px;"
								:src="require('../../assets/images/no-data.png')">
						</div>
						<van-row v-if="applyList.length>0"
							class="apply-bar">
							<van-col span="5"
								class="bar-txt">
								<van-checkbox v-model="applyAllChecked"
									@click="allCheckChange"
									checked-color="#1677FF"
									icon-size="16px">
									全选
								</van-checkbox>
							</van-col>
							<van-col span="5"
								class="bar-txt">共:
								<span style="color:#2C82C9;">{{applyList.length}}</span>&nbsp;笔
							</van-col>
							<van-col span="5"
								class="bar-txt">
								选择&nbsp;<span style="color:#2C82C9;">{{applyResult.length}}</span>&nbsp;笔
							</van-col>
							<van-col span="9">
								<van-button @click="applyClick()"
									class="apply-btn"
									type="info">
									申请开票
								</van-button>
							</van-col>
						</van-row>
					</div>
					<div v-show="active===1">
						<div class="invoice-list">
							<van-checkbox-group v-model="downResult"
								ref="downGroup">
								<div v-for="(down, i) in downList"
									:key="i">
									<div class="comm-seperator"></div>
									<invoice-item :item="down"
										@changecheck="changeCheckDown"></invoice-item>
								</div>
							</van-checkbox-group>
						</div>
						<van-row class="apply-bar">
							<van-col span="5"
								class="bar-txt">
								<van-checkbox v-model="downAllChecked"
									@click="downAllCheck"
									checked-color="#1677FF"
									icon-size="16px">
									全选
								</van-checkbox>
							</van-col>
							<van-col span="5"
								class="bar-txt">共:
								<span style="color:#2C82C9;">{{downList.length}}</span>&nbsp;笔
							</van-col>
							<van-col span="5"
								class="bar-txt">
								选择&nbsp;<span style="color:#2C82C9;">{{downResult.length}}</span>&nbsp;笔
							</van-col>
							<van-col span="9">
								<van-button @click="downClick()"
									class="apply-btn"
									type="info">
									发票下载
								</van-button>
							</van-col>
						</van-row>
					</div>
				</div>
			</van-tab>
		</van-tabs>
		<van-popup v-model="showPicker"
			position="bottom">
			<van-picker show-toolbar
				:columns="columns"
				@confirm="onConfirmNo"
				@cancel="showPicker = false" />
		</van-popup>
		<van-popup v-model="showTimePicker"
			position="bottom">
			<van-picker show-toolbar
				:columns="timecolumns"
				@confirm="onConfirmTime"
				@cancel="showTimePicker = false" />
		</van-popup>
	</div>
</template>

<script>
import InvoiceItem from "./InvoiceItem";
export default {
	name: "InvoiceApply",
	components: {
		InvoiceItem
	},
	data() {
		return {
			value: "",
			timeT: "近一个月",
			timeV: "1",
			columns: [],
			timecolumns: [
				{ text: "近一个月", value: "1" },
				{ text: "近三个月", value: "2" },
				{ text: "近半年", value: "3" },
				{ text: "近一年", value: "4" }
			],
			showPicker: false,
			showTimePicker: false,
			checked: true,
			applyAllChecked: false,
			downAllChecked: false,
			active: 0,
			tabs: [
				{
					title: "发票申请"
				},
				{
					title: "发票下载"
				}
			],
			applyList: [],
			downList: [],
			userList: JSON.parse(localStorage.getItem("userList")),
			applyResult: [],
			downResult: []
		};
	},
	mounted() {
		if (this.$route.query.active) {
			this.active = Number(this.$route.query.active);
		}

		let columns = [];
		for (let i = 0; i < this.userList.length; i++) {
			columns.push(this.userList[i].userno);
		}
		this.columns = columns;
		if (this.columns.length > 0) {
			this.value = this.columns[0];
			this.onChange(this.active);
		}
	},
	methods: {
		allCheckChange() {
			if (
				this.applyList.filter(e => e.active == true).length == this.applyList.length
			) {
				this.applyList.forEach(e => {
					e.active = false;
				});
				this.$refs.checkboxGroup[0].toggleAll(false);
			} else {
				this.applyList.forEach(e => {
					e.active = true;
				});
				this.$refs.checkboxGroup[0].toggleAll(true);
			}
		},
		changeCheck(item) {
			this.applyList[
				this.applyList.findIndex(e => e.pid == item.pid)
			].active = !this.applyList[this.applyList.findIndex(e => e.pid == item.pid)]
				.active;
			this.applyAllChecked =
				this.applyList.filter(e => e.active == true).length ==
				this.applyList.length;
		},
		changeCheckDown(item) {
			this.downList[this.downList.findIndex(e => e.pid == item.pid)].active = !this
				.downList[this.downList.findIndex(e => e.pid == item.pid)].active;
			this.downAllChecked =
				this.downList.filter(e => e.active == true).length == this.downList.length;
		},
		downAllCheck() {
			if (
				this.downList.filter(e => e.active == true).length == this.downList.length
			) {
				this.downList.forEach(e => {
					e.active = false;
				});
				this.$refs.downGroup[1].toggleAll(false);
			} else {
				this.downList.forEach(e => {
					e.active = true;
				});
				this.$refs.downGroup[1].toggleAll(true);
			}
		},
		applyClick() {
			if (this.applyResult.length === 0) {
				this.$toast("请先选择要申请的发票");
				return;
			}
			let seldata = [];
			for (let i = 0; i < this.applyResult.length; i++) {
				for (let j = 0; j < this.applyList.length; j++) {
					if (this.applyResult[i] === this.applyList[j].pid) {
						let seldataDict = {};
						seldataDict["pbatch"] = this.applyList[j].pbatch;
						seldataDict["pid"] = this.applyList[j].pid;
						seldata.push(seldataDict);
					}
				}
			}
			this.$loading();
			this.$http
				.post(this.$api.invoiceApply, {
					seldata: seldata
				})
				.then(res => {
					this.$clear();
					if (res.code === "000") {
						// this.$toast('已提交申请')
						this.countDown();
					} else {
						this.$toast(res.msg);
					}
				});
		},
		downClick() {
			if (this.downResult.length === 0) {
				this.$toast("请先选择要下载的发票");
				return;
			}
			let seldata = [];
			for (let i = 0; i < this.downResult.length; i++) {
				for (let j = 0; j < this.downList.length; j++) {
					if (this.downResult[i] === this.downList[j].pid) {
						let seldataDict = {};
						// seldataDict['pbatch'] = this.applyList[j].pbatch
						seldataDict["pid"] = this.downList[j].pid;
						seldata.push(seldataDict);
					}
				}
			}
			this.$loading();
			this.$http
				.post(this.$api.invoiceDownOk, {
					seldata: seldata
				})
				.then(res => {
					this.$clear();
					if (res.code === "000") {
						// this.$toast('已提交申请')
						window.location.href = res.data[0].url;
					} else {
						this.$toast(res.msg);
					}
				});
		},
		countDown() {
			const toast = this.$toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				message: "倒计时 10 秒"
			});

			let second = 10;
			const timer = setInterval(() => {
				second--;
				if (second) {
					toast.message = `倒计时 ${second} 秒`;
				} else {
					clearInterval(timer);
					// 手动清除 Toast
					this.$toast.clear();
					this.active = 1;
					this.onChange(this.active);
				}
			}, 1000);
		},
		onConfirmNo(value) {
			this.value = value;
			this.showPicker = false;
			this.onChange(this.active);
		},
		onConfirmTime(value) {
			this.timeV = value.value;
			this.timeT = value.text;
			this.showTimePicker = false;
			this.onChange(this.active);
		},
		onChange(value) {
			if (value === 0) {
				this.getInvoiceApplys();
			} else {
				this.getInvoiceDowns();
			}
		},
		getInvoiceApplys() {
			this.$http
				.post(this.$api.invoiceApplys, {
					userno: this.value
				})
				.then(res => {
					if (res.code === "000") {
						res.data.forEach(e => {
							e.active = false;
						});
						this.applyList = res.data;
					} else {
						this.$toast(res.msg);
					}
				});
		},
		getInvoiceDowns() {
			this.$http
				.post(this.$api.invoiceDowns, {
					userno: this.value,
					daterange: this.timeV
				})
				.then(res => {
					if (res.code === "000") {
						this.downList = res.data;
					} else {
						this.$toast(res.msg);
					}
				});
		}
	}
};
</script>

<style lang="less" scoped>
.invoice-apply {
	.tab-content {
		.invoice-list {
			margin: 0 16px;
			margin-bottom: 54px;
			box-shadow: 0px 2px 5px 0px rgba(53, 126, 70, 0.08);
			border-radius: 4px;
		}
		.apply-bar {
			height: 44px;
			position: fixed;
			bottom: 0;
			width: 100%;
			padding: 0 16px;
			background: rgba(255, 255, 255, 1);
			display: flex;
			justify-content: space-between;
			align-items: center;
			.bar-txt {
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(33, 33, 33, 1);
			}
			.apply-btn {
				height: 30px;
				background: #2C82C9;
				border-radius: 3px;
				border-color: #2C82C9;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(255, 255, 255, 1);
			}
		}
	}
}
</style>